module.exports = __webpack_public_path__ + "img/supplier-007.4bcf67d8.png";